<template>
  <div ref="occurring" class="occurring-reports">
    <select-by-type
        :customDataTypes="mostTypes"
        extraClasses="occurring-reports__selected-type"
        :initSelected="selectedMostType"
        textBeforeSelected="most"
        @setDataType="setMostType">
    </select-by-type>

    <select-by-type @setDataType="setReportDataType"></select-by-type>

    <div v-if="graphData && !errorMessage" class="occurring-reports__graph">
      <most-occurring-row
          v-for="(rowData, key) in graphData"
          :key="key"
          :count="rowData.count"
          :percent="rowData.percent"
          :graphData="rowData.data"
          :rowData="rowData"
          :rowName="key"
          :useCurrency="useCurrency">
      </most-occurring-row>
    </div>

    <div v-if="errorMessage" class="occurring-reports__error text-center">
      <p class="occurring-reports__error-text">{{errorMessage}}</p>
    </div>
  </div>
</template>

<script>
  import MostOccurringRow from './MostOccurringRow'
  import ReportsMixin from '../../mixins/ReportsMixin'
  import SelectByType from './SelectByType'

  export default {
    props: {
      isTracked: Boolean,
      error: String,
      graphData: Array,
      wrapperWidth: [Number, String],
    },

    name: 'MostOccurringReport',

    components: {
      MostOccurringRow,
      SelectByType,
    },

    mixins: [ReportsMixin],

    data() {
      return {
        mostTypes: ['purchased category', 'purchased brand', 'frequent spend'],
        selectedMostType: 'purchased category',
      }
    },

    methods: {
      loadData() {
        const graphParams = {
          params: {
            metric: this.metric,
            type: this.selectedMostType
          }
        }
        this.$emit('loadGraphData', 'most_occurring', 'occurring', graphParams)
      },

      setMostType(dataType) {
        if (this.selectedMostType !== dataType) {
          this.selectedMostType = dataType
          this.loadData()
        }
      },

      setReportDataType(dataType) {
        if (this.reportDataType !== dataType) {
          this.reportDataType = dataType
          this.loadData()
        }
      },
    },

    created() {
      this.loadData()
    },

    computed: {
      errorMessage: function () {
        let message = this.error || null
        const isNoDataMessage = message === 'no categories or brands found',
          noDataMessage = 'there is not enough data to display this chart'

        return isNoDataMessage ? noDataMessage : message
      }
    },
  }
</script>